<template>
  <div class="lh-homes">
    <!--bg-->
    <div class="lh-index-bg img" :class="[index.animatexy1]"></div>
	<!--开场动画-->
    <div class="lh-index-load img" :class="[index.animatexy]">
    	<!--人物-->
        <div class="lh-figure"><div class="icon" :style="{backgroundImage:'url('+index.figure+')'}"></div></div>
        <!--<div class="lh-bg img" :style="{backgroundImage:'url('+index.bg+')'}"></div>-->
        <div class="lh-stage img zindex4" :style="{backgroundImage:'url('+index.stage+')'}"></div>
        <div class="lh-flowers img zindex5" :style="{backgroundImage:'url('+index.flowers+')'}"></div>
        <div class="lh-rockets img zindex3" :style="{backgroundImage:'url('+index.rockets.rockets+')'}"></div>
        <div class="lh-rockets1 img zindex2" :style="{backgroundImage:'url('+index.rockets.rockets1+')'}"></div>
        <div class="lh-rockets2 img zindex1" :style="{backgroundImage:'url('+index.rockets.rockets2+')'}"></div>
    </div>
    <!--内容-->
    <div class="lh-index" :class="[index.show]">
    	<div class="lh-icon icon1" @click="gotoNext($event)" style="background-image:url(img/index/icon1.png);">
        	<div class="feiji" style="background-image:url(img/index/icon4.png);"></div>
        </div>
        <div class="lh-icon icon2" style="background-image:url(img/index/icon2.png);">
        	<div class="feiji" style="background-image:url(img/index/icon4.png);"></div>
        </div>
        <div class="lh-icon icon3" style="background-image:url(img/index/icon3.png);">
        	<div class="feiji" style="background-image:url(img/index/icon4.png);"></div>
        </div>
    </div>
  </div>
</template>

<script>
export default{
	data(){
		return {
			loading:'public/img/_preloader.gif',
		    index:{
				bg:'img/bg1.jpg',
				bg1:'img/bg2.jpg',
				bg2:'img/bg3.jpg',
				bg3:'img/bg4.jpg',
				figure:'img/figure.png',
				flowers:'img/flowers.png',
				stage:'img/stage.png',
				rockets:{
					rockets:'img/rockets.png',
					rockets1:'img/rockets1.png',
					rockets2:'img/rockets2.png'	
				},
				animatexy:'',
				animatexy1:'',
				show:''
			}
		}
	},
	created(e){
		var that=this;
		if($(window).width()>980){
		setTimeout(function(){
			 //$('.lh-rockets').css({opacity:0});
			 TweenLite.to('.lh-rockets', 1, {opacity:0,onComplete:function(){
				 TweenLite.to('.lh-rockets2',0,{opacity:1,onComplete:function(){
					$('.lh-rockets2').addClass('movexy');
					setTimeout(function(){
						that.index.animatexy='animatexy';
						that.index.animatexy1='animatexy1';
						that.index.show='show';
					},1300);//1300	 
				 }});	
				 TweenLite.to('.lh-rockets1',.45,{opacity:0}); 
			 }});	 
		 },8000);//1000
	}
		 $('.lh-icon.icon1').hover(function(){
			$('.lh-icon.icon4').css({
				'transform':'scale(.8)'	
			});	 
		 });
	},
	methods:{
		gotoNext(e){
			var that=this,tag = $(e.currentTarget);
			tag.addClass('on');
			setTimeout(function(){
				that.$router.replace("/Culture");
			},2000);
			//this.$router.push("/Culture")
		}
	}
}
</script>
